import React from 'react';
import { 
    Popover, 
    PopoverContent, 
    Flex, 
    PopoverTrigger, 
    Text, 
    Box,
    Icon,
    Button 
} from '@chakra-ui/react';
import { PropertiesDropdownProp } from '../property/Property.types';
import { BsFilter, BsPlus } from 'react-icons/bs';
import PropertyDropdown from './PropertyDropdown';
import { SearchProperty } from '../property/SearchProperty';
// import { SortableProperties } from '../property/PropertyList';

export function PropertiesDropdown({
    children,
    properties,
    onPropertyAdd,
    onPropertyDrag,
    onPropertyDelete,
    onPropertyUpdate,
    onPropertyDuplicate
  }: PropertiesDropdownProp) {
    return (
      <Popover>
        <PopoverTrigger>{children}</PopoverTrigger>
        <PopoverContent zIndex={99999} paddingY="1rem" width="fit-content">
          <Flex paddingX="1rem" alignItems="center">
            <Icon as={BsFilter} w={6} h={6} />
            <Text fontSize="14px" fontWeight={500} paddingLeft="0.5rem">
              Properties
            </Text>
          </Flex>
          <Box paddingX="1rem">
            <SearchProperty onChange={() => {}} />
          </Box>
          {/* <SortableProperties
            // lockAxis="y"
            useDragHandle
            properties={properties}
            onSortEnd={onPropertyDrag}
            onChange={onPropertyUpdate}
            onDelete={onPropertyDelete}
            onDuplicate={onPropertyDuplicate}
          /> */}
          <Box paddingX="1rem" paddingTop="0.5rem">
            <PropertyDropdown onChange={onPropertyAdd}>
              <Button leftIcon={<BsPlus />} size="xs" width="100%">
                New property
              </Button>
            </PropertyDropdown>
          </Box>
        </PopoverContent>
      </Popover>
    );
  }